export function when<T, V>(
  val: T | false | null | undefined | 0 | "" | void,
  f: (val: T) => V,
): V | undefined {
  if (val) {
    return f(val);
  }
}

export function whenNotEmpty<T, V>(arr: T[] | undefined, f: (arr: T[]) => V): V | undefined {
  if (arr && arr.length) {
    return f(arr);
  }
}

export function withValue<T, V>(val: T, f: (val: T) => V): V {
  return f(val);
}

/**
 * Wraps the given function so that invocations are deferred to the next event loop.
 */
export const deferred =
  <T extends (...args: never[]) => void>(f: T) =>
  (...args: Parameters<T>): void => {
    setTimeout(() => {
      f(...args);
    });
  };

/**
 * Invoke `f` right away and return the result. Useful for on-off switch statements
 * (while we're waiting for https://github.com/tc39/proposal-pattern-matching)
 *
 * ```tsx
 * <SomeComponent
 *   description={immediate(() => {
 *     switch (props.status) {
 *       case "pending":
 *         return { key: "status.pending" };
 *       case "done":
 *         return { key: "status.done" };
 *       case "overdue":
 *         return { key: "status.overdue" };
 *     }
 *   })}
 * />
 *
 * ```
 * @param f
 */
export const immediate = <T>(f: () => T): T => f();
